import { FC } from "react";
import { createBrowserRouter, createRoutesFromElements, Navigate, Outlet, Route, RouterProvider } from "react-router-dom";
import versionSyncListener from "../../route/versionSyncService/versionSyncService";
import ShortUrlHandler from "./ShortUrlHandler";
import InvalidShortUrl from "./InvalidShortUrl";

const ShortUrlRouter: FC = () => {
    const routes = createBrowserRouter(
        createRoutesFromElements(
            <Route path="" element={<Outlet />}>
                <Route index path="/:code?" element={<ShortUrlHandler />} />
                <Route path="/not-valid" element={<InvalidShortUrl />} />
                <Route path="/*" element={<Navigate to="/not-valid" />} />
            </Route>,
        ),
    );

    routes.subscribe(versionSyncListener);

    return <RouterProvider router={routes} />;
};

export default ShortUrlRouter;
